import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { default as ReactDatePicker } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class CustomInput extends React.PureComponent {
  render() {
    const { onClick, value, placeholder } = this.props;
    return (
      <input
        onClick={onClick}
        value={value}
        type="text"
        readOnly={true}
        placeholder={placeholder}
      />
    );
  }
}

export default class DatePicker extends Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func,
      value: PropTypes.string
    }).isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string
    }).isRequired
  };

  static defaultProps = {
    inputValueFormat: null
  };

  state = {
    selectedDate: null
  };

  constructor(props) {
    super(props);

    if (this.props.input.value) {
      this.state.selectedDate = new Date(this.props.input.value);
    }
  }

  handleChange = date => {
    const res = date ? new Date(date).toString() : null;

    this.setState({
      selectedDate: date
    });
    this.props.input.onChange(res);
  };
  render() {
    const {
      meta: { touched, error },
      ...rest
    } = this.props;

    return (
      <Fragment>
        <ReactDatePicker
          {...rest}
          selected={this.state.selectedDate}
          onChange={this.handleChange}
          calendarClassName={"CustomDatePicker"}
          customInput={<CustomInput />}
        />
        {touched &&
          error && (
            <span className="datepicker__error">
              <FormattedMessage id={error} />
            </span>
          )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/custom-fields/datepicker.js